import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import PropTypes from 'prop-types';
import React from 'react';

import OnlyDesktop from '@/components/ui/OnlyDesktop/OnlyDesktop';

import { Wrapper } from './Arrow.style';

const Arrow = ({ direction, onClick }) => {
  const Icon =
    direction === 'left' ? ChevronLeftOutlinedIcon : ChevronRightOutlinedIcon;

  return (
    <OnlyDesktop>
      <Wrapper direction={direction} onClick={onClick}>
        <Icon
          fontSize="small"
          color="primary"
          name={direction === 'left' ? 'arrow-left' : 'arrow-right'}
        />
      </Wrapper>
    </OnlyDesktop>
  );
};

Arrow.propTypes = {
  direction: PropTypes.oneOf(['right', 'left']),
  onClick: PropTypes.func,
};

Arrow.defaultProps = {
  direction: 'right',
  onClick: () => {},
};

export default Arrow;
